import { Variant } from './utils';

export function updateVariantDiscountCode(variant: Variant): void {
  const isBundle = variant.sku.slice(0, 3) === 'BND';

  const discountCodeContainer = document.getElementById('productDiscountCode');

  if (!discountCodeContainer) {
    return;
  }

  if (isBundle) {
    discountCodeContainer.classList.add('hidden');
  } else {
    discountCodeContainer.classList.remove('hidden');
  }
}

export function updateVariantSavings(variant: Variant): void {
  const savingsContainer = document.querySelectorAll(
    '[data-savings-container]'
  );

  const savings = variant.compare_at_price - variant.price;

  savingsContainer.forEach((container) => {
    if (savings <= 0 || isNaN(savings)) {
      container.parentElement?.classList.add('hidden');
      container.textContent = '';
      return;
    }

    container.parentElement?.classList.remove('hidden');
    container.innerHTML = `${window.Shopify.formatMoney(
      savings,
      window.theme.moneyFormat
    )}`;
  });
}
